export const THAI_CHARACTERS = {
  searchResultAbout: 'ผลการค้นหาเกี่ยวกับ',
  project: 'โครงการ',
  nationwide: 'ทั่วประเทศ',
  allPropertyInThailand: 'รวมอสังหาริมทรัพย์ทั่วประเทศ',
  propertyIn: 'อสังหาฯย่าน',
  zone: 'ย่าน',
  in: 'ย่าน',
  trainline: 'รถไฟฟ้า',
  trainStation: 'สถานี',
};

const isLocation = (taxonomy: string) =>
  ['district', 'zone', 'road', 'metro_station'].includes(taxonomy);

interface TitleParams {
  searchTitle: string;
  termsTaxonomy?: string;
  freeText?: string;
  propertyTypeInTh?: string;
  parent?: string;
}

export const titleGenerator = (params: TitleParams) => {
  const { searchTitle, termsTaxonomy, freeText, propertyTypeInTh, parent } =
    params;

  if (!isLocation(termsTaxonomy)) {
    if (freeText) {
      return `${THAI_CHARACTERS.searchResultAbout}${freeText}`;
    } else {
      if (propertyTypeInTh) {
        return `${THAI_CHARACTERS.project}${propertyTypeInTh}${THAI_CHARACTERS.nationwide}`;
      } else {
        return THAI_CHARACTERS.allPropertyInThailand;
      }
    }
  } else {
    if (propertyTypeInTh) {
      return `${propertyTypeInTh}${THAI_CHARACTERS.in}${searchTitle}`;
    }

    if (termsTaxonomy === 'metro_station') {
      if (parent) {
        return `${THAI_CHARACTERS.trainStation}${searchTitle}`;
      } else {
        return `${THAI_CHARACTERS.trainline} ${searchTitle}`;
      }
    } else {
      return `${THAI_CHARACTERS.propertyIn}${searchTitle}`;
    }
  }
};
